









































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import InformationChart from '@/prioritization/chart/information-chart.vue';
import { getQueryString } from '@/Api/api_data';
import Api from '@/Api/api_simulaion';
import { EChartsOption, ECharts, init } from 'echarts';
import MessageBus from '@/Utils/message/message-bus';
import { PlanData, PlanList, SchemeInformation, ProjectInfo } from '@/prioritization/interface/interface';
import Tools from '@/component/template/tools/tools';
import { arrayTransposition } from '@/Utils/average';
import { flatten, concat } from 'lodash';

/**
 * 框架入口文件
 */
@Component({
    components: {
        InformationChart,
    },
})
export default class DetailedInformation extends Vue {
    /**当前图表选择典型月 */
    month = 'January Wednesday';
    /** */
    groupList: string[] = [];
    /** 图表数据 */
    resultDataDict = {};
    /** 典型日 */
    typicalDay: string[] = [];
    /** */
    @Prop({ default: () => 1 })
    initialPlanId!: number;

    /** planId */
    planId = this.initialPlanId;

    /**
     * 监听方案选择变化
     */
    @Watch('initialPlanId', { immediate: true })
    watchPlanId(): void {
        this.planId = this.initialPlanId;
    }

    /** 方案列表 */
    @Prop({ default: () => [] })
    planList!: PlanList;

    /**
     * loading
     */
    loading = false;

    /**
     * usrDefinedName
     */
    usrDefinedName = '';

    /**
     * cloudPssTheme
     */
    get cloudPssTheme(): string {
        return this.$store.getters.getTheme;
    }

    /**
     * projectInfo
     */
    get projectInfo(): ProjectInfo {
        return this.$store.state.projects;
    }

    /**
     * @author guan
     * @description 加载典型日表
     * @return void
     */
    private getTypicalDay(): void {
        Api.getOptimizationResult({
            resultType: 2,
            simuid: getQueryString()['simu_id'] as unknown as number,
            taskid: this.taskId,
            u_name: this.defaultName,
            planId: this.planId,
        })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((data: any) => {
                this.typicalDay = data.data.map((x) => x.typicalDay);
                this.month = this.typicalDay[0];
            })
            .catch((e) => console.log(e));
    }

    /**
     * @author guan
     * @description upDataDefaultName 更新默认选中的默认曲线
     * @param item SchemeInformation
     * @return void
     */
    upDataDefaultName(item: SchemeInformation): void {
        if (this.defaultName === item.key) {
            MessageBus.Notification('info', { description: '', message: '当前选择未做更改' });
            return;
        } else {
            this.resultDataDict = {};
            this.group = '';
            this.groupList = [];
            this.mode = 'draw';
            this.defaultName = item.key;
            this.usrDefinedName = item.usrDefinedName;
        }
    }

    /** */
    get option(): EChartsOption {
        return {
            title: {
                text: '',
                left: '45%',
            },
            grid: {
                containLabel: true,
                left: 10,
            },
            legend: {
                align: 'left',
                left: 10,
                top: 25,
                type: 'scroll',
                textStyle: {
                    color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                },
            },
            brush: {
                toolbox: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
                xAxisIndex: 0,
            },
            toolbox: {
                feature: {
                    iconStyle: {
                        color: this.cloudPssTheme === 'dark' ? '#d5d4d4' : '#666363',
                    },
                    magicType: {
                        type: ['line', 'bar'],
                    },
                },
            },
            tooltip: {
                axisPointer: {
                    type: 'cross',
                    crossStyle: {
                        color: '#999',
                    },
                },
            },
            xAxis: {
                data: [],
                name: 'X Axis',
                silent: false,
                axisLine: {
                    onZero: true,
                    lineStyle: {
                        color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                    },
                },
                splitLine: { show: false },
                splitArea: { show: false },
                axisLabel: {
                    color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                },
            },
            dataZoom: [
                {
                    type: 'slider',
                    yAxisIndex: 0,
                    filterMode: 'none',
                },

                {
                    type: 'inside',
                    yAxisIndex: 0,
                    filterMode: 'none',
                },
            ],
            yAxis: {
                inverse: false,
                splitArea: { show: false },
                nameTextStyle: {
                    color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                },
                axisLabel: {
                    formatter: '{value}',
                    color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                },
                axisLine: {
                    onZero: true,
                    lineStyle: {
                        color: '#0e61ef',
                    },
                },
                splitLine: {
                    show: false,
                },
            },

            series: [],
        };
    }

    /** 当前图表的数据名 */
    defaultName = '';
    /** */
    @Prop({ default: () => '' })
    taskId!: string;
    /** */
    private group = '';
    /** */
    mode = 'bar';
    /** 图表实例 */
    private chart?: ECharts;

    /**
     * @author guan
     * @description
     * @return void
     */
    @Watch('month')
    onMonthChange(): void {
        this.loadDetailData();
    }

    /**
     * @author guan
     * @description echarts图初始化
     * @return void
     */
    initEcharts(): void {
        if (!this.$refs['chart_component']) return;
        if (this.chart) return;
        this.chart = init(this.$refs['chart_component'] as HTMLDivElement);
        window.onresize = () => {
            this.chart?.resize();
        };
        this.chart.setOption(this.option, true);
    }

    /** */
    planData: PlanData = {} as PlanData;

    /**
     * @author guan
     * @description 设置默认的选中曲线
     * @return void
     */
    mounted(): void {
        /** 初始化 */
        this.initEcharts();
        /** 设置默认的额defaultName */
        this.defaultName = 'systemData';
        /** 初始化表格 */
        void this.initTable();
        /** 获取典型日 */
        this.getTypicalDay();
    }

    /**
     * initTable
     */
    async initTable(): Promise<void> {
        const data = await this.getPlanData(this.planId, this.taskId);
        for (const item of data.data) {
            for (const key in item) {
                if (!isNaN(Number(item[key]))) {
                    item[key] = Number(item[key]).toFixed(2);
                }
            }
        }
        this.planData = data;
    }

    /** 样式 */
    readonly itemStyle = {
        normal: {},
        emphasis: {
            barBorderWidth: 1,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0,0,0,0.5)',
        },
    };

    /**
     * 根据事件变化，刷新当前图表，展示不同的数据
     */
    private refreshChart(): void {
        if (this.mode === 'table') {
            this.chart = undefined;
            this.systemDataColumns = this.resultDataDict[this.month].headerDesc;
            this.resultDataDict[this.month].bodyData.map((item) => {
                return this.handleTableData(item);
            });
            this.systemBodyData = this.resultDataDict[this.month].bodyData;
        } else if (this.mode === 'draw') {
            let month = this.resultDataDict[this.month] || {};
            this.initEcharts();
            if (Object.keys(month).length > 0) {
                let group2 = month[this.group];
                let option = JSON.parse(JSON.stringify(this.option));
                if (group2) {
                    option.legend.data = group2.legend.data;
                    option.xAxis = { ...option.xAxis, ...group2.xAxis };
                    option.series = group2.series;
                }
                this.chart?.setOption(option, true);
            }
        }
    }

    /**
     *  表格数据保留两位小数
     */
    handleTableData(item: Record<string, string | number>): Record<string, string | number> {
        for (const key in item) {
            if (typeof item[key] === 'number') {
                item[key] = (item[key] as number).toFixed(2);
            }
        }
        return item;
    }

    /**
     * @author guan
     * @description
     * 加载设备详细数据
     * 使用vue 监听group的变化来更新图表
     * 如果group相同则主动刷新图表
     * 一种设备的一次取一个月的数据，并存储到全局变量中（用于减少请求）
     * 防止数据量过大只存一个设备的数据，切换设备后数据需要重新请求
     * @return void
     */
    @Watch('defaultName', { deep: true })
    getChartData(newVal: string): void {
        if (this.taskId.length === 0 || newVal.length === 0) {
            return;
        }
        this.loadDetailData();
    }

    /**
     * @author guan
     * @description 加载数据
     * @return void
     */
    loadDetailData(): void {
        if (!this.resultDataDict[this.month]) {
            const id = getQueryString()['simu_id'];

            Api.getOptimizationResult({
                resultType: 3,
                simuid: id,
                taskid: this.taskId,
                u_name: this.defaultName,
                typicalDay: this.month,
                planId: this.planId,
            })
                .then(
                    async (
                        //eslint-disable-next-line
                        data: any,
                    ) => {
                        await this.dealDetailData(data.data);
                        this.groupList = Object.keys(this.resultDataDict[this.month]);
                        if (this.group.length > 0) {
                            this.refreshChart();
                        } else {
                            this.group = this.groupList[0];
                        }
                    },
                )
                .catch((e) => e);
        } else {
            this.refreshChart();
        }
    }

    /** systemDataColumns */
    systemDataColumns = [];

    /** systemBodyData */
    systemBodyData = [];

    /**
     * 解析获取到的设备数据，按月存储到 resultDataDict 中
     * 两种数据格式，一种为柱状图，一种为曲线
     *
     * @param {*} data 请求到的数据
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
    dealDetailData(data: any): Promise<void> {
        return new Promise((resolve) => {
            let ret = data[0].data;
            let month = {};
            if (ret.type === 'table') {
                this.mode = 'table';
                const data = ret.data.columns;
                const headerDesc = data.map((val, i) => ({
                    dataIndex: `row-${i}`,
                    key: `row-${i}`,
                    title: val.name,
                    align: 'center',
                }));
                const bodyData = data.reduce((a, val, j) => {
                    const item = val.data;
                    item.forEach((val, i) => {
                        a[i] = a[i] ?? {};
                        a[i][`row-${j}`] = val;
                    });
                    return a;
                }, []);
                month = {
                    headerDesc,
                    bodyData,
                };
            } else {
                let drawData = ret;
                let drawGroup = ret.groupDesc;
                if (!drawGroup) {
                    MessageBus.Notification('warning', { message: '暂无数据', description: '' });
                    return;
                }
                for (let val of drawGroup) {
                    let group = month[val.desc] || {
                        legend: { data: [] },
                        xAxis: {
                            data: [],
                            name: '小时',
                        },
                        series: [],
                    };
                    let series = group.series;
                    let showGoup = 0;
                    for (let index = 0; index < val.keyset.length; index++) {
                        const element = val.keyset[index];
                        series[index] = series[index] || {
                            name: element,
                            type: 'line',
                            itemStyle: this.itemStyle,
                            data: [],
                        };
                        let lineData = drawData[element];
                        if (lineData) {
                            showGoup = 1;
                            if (group.legend.data.indexOf(element) === -1) {
                                group.legend.data.push(element);
                            }
                            for (const val of lineData) {
                                if (!group.xAxis.data.includes(val[0])) {
                                    group.xAxis.data.push(val[0]);
                                }
                                series[index].data.push(val[1]);
                            }
                        }
                    }
                    if (showGoup) {
                        month[val.desc] = group;
                    }
                }
            }
            this.resultDataDict[this.month] = month;
            resolve();
        });
    }

    /**
     * @author guan
     * @description
     * @return void
     */
    @Watch('group')
    onGroupChange(): void {
        this.refreshChart();
    }

    /**
     * onThemeChange
     */
    @Watch('cloudPssTheme')
    onThemeChange(): void {
        this.refreshChart();
    }

    /**
     * selectComparisonPlan
     */
    async selectComparisonPlan(id: number): Promise<void> {
        this.planData = await this.getPlanData(id, this.taskId);
        this.resultDataDict = {};
        this.loadDetailData();
    }

    /** 获取数据 */
    getPlanData(planId: number, taskId: string): Promise<PlanData> {
        if (planId === undefined) {
            MessageBus.Notification('warning', { message: '提示', description: '当前未配置方案id!' });
            return new Promise((resolve) => {
                resolve({} as PlanData);
            });
        }
        return (
            Api.getOptimizationResult({ resultType: 1, simuid: getQueryString()['simu_id'], taskid: taskId, planId: planId })
                /* eslint-disable-next-line */
                .then((res: any) => {
                    const source = res.data;
                    const headerDesc = res.data[0]?.data.headerDesc;
                    const detailColumn: Array<Record<string, unknown>> = headerDesc.map((column) => ({
                        dataIndex: column.key,
                        key: column.key,
                        title: column.hearderName,
                        align: 'center',
                    }));

                    const data: Array<Record<string, unknown>> = [];

                    source.forEach((item) => {
                        const dataItem = item.data.data;

                        const rowData: Record<string, string | number> = {};
                        for (const key in dataItem) {
                            if (typeof item[key] === 'number') {
                                rowData[key] = dataItem[key].toFixed(2);
                                continue;
                            }
                            rowData[key] = dataItem[key];
                        }
                        rowData['key'] = dataItem.compName;
                        data.push(rowData);
                    });

                    detailColumn.push({
                        title: '查看曲线',
                        align: 'center',
                        width: 120,
                        fixed: 'right',
                        scopedSlots: { customRender: 'operation' },
                    });
                    return { data: data, detailColumn: detailColumn };
                })
                .catch((e) => e)
        );
    }

    /**
     * 下载总计方案数据，分为下载全部元件标识符的数据和单一标识符的数据，后台接口一致，返回的数据结果不同
     * 按照日期重新生成excel数据
     *
     * @author guan
     * @description 下载全部数据报表
     */
    async download(): Promise<void> {
        try {
            const projectName = this.projectInfo ? this.projectInfo.name : '无';
            this.loading = true;
            const { typicalDay, planId, taskId } = this;
            const request = typicalDay.map((x) => {
                const id = getQueryString()['simu_id'];
                return Api.getOptimizationResult({
                    resultType: 3,
                    simuid: id,
                    taskid: taskId,
                    u_name: this.defaultName,
                    typicalDay: x,
                    planId: planId,
                });
            });
            /** 获取当前全部的表格数据 */
            const data = await Promise.all(request);
            if (this.defaultName === 'systemData') {
                /** 去除掉无限嵌套的data,生成全部数据组成的数组 */
                let source = data
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .map((v: any) => {
                        if (v.data && Array.isArray(v.data) && v.data[0].data && v.data[0].data.data) {
                            return v.data[0].data.data;
                        } else {
                            return {};
                        }
                    })
                    .flat(5);
                if (!source) {
                    throw new Error('数据解析错误');
                }
                const arr = source.map((x) => {
                    return x.columns;
                });
                const res = arr.map((data) => {
                    const list = data.map((val) => {
                        return val.name;
                    });
                    const bodyData = data.reduce((a, val, j) => {
                        const item = val.data;
                        item.forEach((val, i) => {
                            a[i] = a[i] ?? {};
                            a[i][list[j]] = val;
                        });
                        return a;
                    }, []);
                    return bodyData;
                });
                const newArr = arrayTransposition(res);
                const r = newArr.map((item) => {
                    return item.map((x, i) => {
                        x['日期'] = this.typicalDay[i];
                        return x;
                    });
                });
                const title = projectName + '-' + '方案总数据';
                /** 开始调用下载接口 */
                void (await Tools.initNewSheets(title, r));
                this.loading = false;
            } else {
                const arr: string[][][] = [];
                const header = data.map((v) => {
                    return Object.keys(v.data[0].data).slice(1);
                });
                data.forEach((v) => {
                    const nameList = Object.keys(v.data[0].data).slice(1);
                    const dataObj = v.data[0].data;
                    const tmp: string[][] = [];
                    for (let i of nameList) {
                        const list = dataObj[i].map((x) => x[1]);
                        tmp.push(list);
                    }
                    const t = arrayTransposition(tmp);
                    arr.push(t);
                });
                const newArr = flatten(arr);
                const title = projectName + '-' + this.usrDefinedName;
                const time = new Array(24).fill('').map((_x, index) => {
                    return `${index}:00:00`;
                });
                const r = newArr.map((x, i) => {
                    const n = Math.floor(i / 24);
                    const t = time[i % 24];
                    x.unshift(t);
                    const d = this.typicalDay[n];
                    x.unshift(d);
                    return x;
                });
                const column = concat(['日期', '时间'], header[0]);
                /** 开始调用下载接口 */
                void (await Tools.initNewSheets(title, r, column));
                this.loading = false;
            }
        } catch (e) {
            throw new Error('后台接口错误，请联系管理员');
        }
    }

    /**
     * returnScheme
     */
    @Emit('returnScheme')
    returnScheme(): void {
        return;
    }
}
